<template>
    <div class="contact">
        <sw-parallax
            style="background-image: url('/static/media/shutterstock_224220988.jpg');
                height: 300px; background-position-y: -350px;">
        </sw-parallax>
        <div class="container">
            <div class="row">
                <div class="column">
                    <article>
                        <h2>Waar we werken</h2>
                        <p>
                            In Goënga, tussen de landerijen vindt u onze werk-, denk- en overlegplek. Goënga is ongeveer
                            5-10 minuten rijden vanaf Sneek.
                        </p>
                    </article>
                </div>
            </div>

            <div class="row" style="margin-bottom: 60px;">
                <div class="three columns">
                    <span class="address-title">Ons bezoekadres</span>
                    <ul class="contacts">
                        <li>
                            Goaijengeamieden 9
                        </li>
                        <li>
                            8628 SJ Go&euml;nga
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <GmapMap
            :center="{lat:53.0500369, lng:5.7070769}"
            :zoom="10"
            map-type-id="terrain"
            style="width: 100%; height: 500px; margin-bottom: 60px;"
        >
            <GmapMarker
                :position="{lat:53.0500369, lng:5.7070769}"
            />
        </GmapMap>
        <div class="container">
            <div class="row">
                <div class="column">
                    <h2>Bericht achterlaten</h2>
                </div>
            </div>
            <form @submit.prevent="">
                <div class="row">
                    <div class="column">
                        <input class="u-full-width" type="text" placeholder="Je naam" v-model="name"
                               :class="{'error': $v.name.$error}">
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <input class="u-full-width" type="email" placeholder="Je email" v-model="email"
                               :class="{'error': $v.email.$error}">
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <input class="u-full-width" type="text" placeholder="Je telefoonnummer" v-model="phone"
                               :class="{'error': $v.phone.$error}">
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <input class="u-full-width" type="text" placeholder="gold" v-model="honey"
                               name="the_natures_gold">
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <textarea class="u-full-width" placeholder="Het bericht dat je wilt achterlaten"
                                  v-model="message" :class="{'error': $v.message.$error}"></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="column">
                        <button class="button-primary" type="submit"
                                :disabled="sending" @click="send_contact_form">
                            Versturen
                        </button>
                        <span v-show="$v.$invalid && tried" class="error_message" key="error_message">
                            Sommige velden zijn verplicht
                        </span>
                        <span v-show="send" class="success_message" key="success_message">
                            Formulier verstuurd
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import * as VueGoogleMaps from "vue2-google-maps";
    import SwParallax from "@/components/Parallax.vue";
    import {required} from "vuelidate/lib/validators";

    const Ajax = require('simple-ajax');

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyAAUW6qgI8pxhziU7tIFxR0d24VNYZ_TXg',
            libraries: 'places',
        },
    });

    export default {
        metaInfo: {
            title: "Contact",
            meta: [
                {
                    'property': 'og:url',
                    'content': url + 'contact',
                    'vmid': 'og:url'
                },
                {
                    'property': 'og:title',
                    'content': 'Contact - SwBase Systems BV - Swbase.com',
                    'vmid': 'og:title'
                },
            ]
        },
        components: {
            SwParallax
        },
        data() {
            return {
                name: "",
                email: "",
                phone: "",
                message: "",
                honey: "",
                sending: false,
                send: false,
                tried: false,

                token: null,
            }
        },
        validations: {
            name: {required},
            email: {required},
            phone: {required},
            message: {required},
        },
        methods: {
            send_contact_form() {
                const self = this;
                if (self.sending) {
                    return false;
                }

                self.tried = true;

                self.$v.$touch();
                if (self.$v.$invalid) {
                    return;
                }

                if (self.honey) {
                    return;
                }

                if (!self.token) {
                    return;
                }

                // self.sending = true;
                self.send = false;

                const ajax = new Ajax({
                    url: "https://us-central1-swbase-website.cloudfunctions.net/contactForm",
                    method: 'POST',
                    data: JSON.stringify({
                        name: self.name,
                        email: self.email,
                        phone: self.phone,
                        message: self.message,
                        token: self.token,
                    })
                });

                ajax.on('success', response => {
                    self.name = "";
                    self.email = "";
                    self.phone = "";
                    self.message = "";
                    self.honey = "";
                    self.sending = false;
                    self.send = true;
                    self.tried = false;

                    self.run_captcha();
                    
                    self.$v.$reset();
                });

                ajax.send();
            },
            run_captcha() {
                const self = this;
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute('6LdDIXkUAAAAAEvXDmwdpxc0TzHl5nOhx7ruvGKv', {action: 'contact_form'})
                        .then(token => {
                            self.token = token;
                        });
                });
            }
        },
        mounted() {
            const self = this;
            self.run_captcha();
        }
    };
</script>

<style scoped="scoped">
    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    ul li {
        font-size: 20px;
        margin-bottom: 2px;
    }

    .address-title {
        font-weight: 400;
        font-size: 25px;
    }
</style>